"use client";

import { useEffect } from "react";
import { useAppSelector } from "../slice/hooks";
import { getSiteTitle } from "../slice/site-title-slice";

const SiteTitleManager = () => {
  const title = useAppSelector(getSiteTitle);

  useEffect(() => {
    if (!title) return;
    document.title = title;
  }, [title]);

  return null;
};

export default SiteTitleManager;
